export default __webpack_public_path__ + "static/media/add_list_collection_project-4.23f534be.png";